// extracted by mini-css-extract-plugin
module.exports = {"container":"LottieAnimation_container__1LUUu"};